import { usePathname } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';

import { useHeaderFlyoutStore, useHeaderLayoutStore } from '../../../shared';

export function useDesktopMenu() {
    const pathname = usePathname();
    const [openMenu, setOpenMenuState] = useState<string | null>(null);
    const [portalContainer, setPortalContainer] = useState<HTMLElement | null>(null);
    const isDesktopMenu = useHeaderLayoutStore(state => state.isDesktopMenu);
    const setFlyoutOpen = useHeaderFlyoutStore(state => state.setFlyoutOpen);

    function setOpenMenu(value: string | null) {
        if (value && !isDesktopMenu) return;

        setOpenMenuState(value);
        setFlyoutOpen('menu', Boolean(value));
    }

    // Keep the popup in the header's positioning context so both move together during scroll.
    const setNavigationRoot = useCallback((element: HTMLElement | null) => {
        setPortalContainer(element?.closest<HTMLElement>('.header__main-section-sticky') ?? null);
    }, []);

    // CSS switches the visible Menu without unmounting either tree.
    // The popup is portaled outside that tree, so CSS cannot close it when Desktop becomes hidden.
    useEffect(() => {
        if (isDesktopMenu) return;

        setOpenMenuState(null);
        setFlyoutOpen('menu', false);
    }, [isDesktopMenu, setFlyoutOpen]);

    useEffect(() => {
        setOpenMenuState(null);
        setFlyoutOpen('menu', false);
    }, [pathname, setFlyoutOpen]);

    useEffect(() => () => setFlyoutOpen('menu', false), [setFlyoutOpen]);

    return {
        closeMenu: () => setOpenMenu(null),
        openMenu,
        portalContainer,
        setNavigationRoot,
        setOpenMenu,
    };
}
